module.exports = __webpack_public_path__ + "img/icon_red_hh.0f9e00f9.png";